<div class="read-more">
  <a *ngIf="!isShown" (click)="toggleShown()" class="more-btn" id="more-btn">Read more</a>

  <div class="more animation-slide-down" [ngClass]="{'shown': isShown}" id="more">
    <p>{{text}}</p>
    <a (click)="toggleShown()" class="less-btn" id="less-btn">Less</a>
  </div>
</div>

